import {blocks, gpu, lutify, luts, UI} from '@/assets/js/Boot';
import * as _utils from '@/assets/js/Utilities';
import tippy, {delegate as tippyDelegate} from 'tippy.js';
import Cookies from 'js-cookie';
import {createPopper} from '@popperjs/core';

import $ from 'jquery';
import 'jquery-ui-bundle';
import 'jquery-knob';
import 'zurb-twentytwenty/js/jquery.event.move';
import 'zurb-twentytwenty/js/jquery.twentytwenty';
import 'round-slider';

export default class AppUI {
	constructor() {
		this.container = {
			compares: $("#candidates-container"),
			blocks: $("#blocks-container"),
			projectNavigator: $("#project-navigator-container"),
			sidebarSelector: $("#left-sidebar-tabs"),
			main: $("#wrapper"),
			mainCanvases: $("#wrapper > #content"),
			lutPreviews: $("#previews-list-container"),
			mainLayoutRight: $("#app-layout-right-column"),
			previewsSidebarSelector: $("#right-sidebar-tabs"),
			previewsSidebarContainer: $("#lut-previews-container"),
			lookMenu: $("#look-menu-container"),
			appView: $("#app-view"),
			mainLayoutLeft: $("#app-layout-left-column"),
			mainLayoutMiddle: $("#main-layout-middle"),
			user: $("#user-container"),
			status: $("#status-container"),
			mainLayoutMiddleBottomArea: $("#main-layout-middle__bottom-area"),
			imageTools: $("#image-tools"),
			scopes: $("#scopes-container"),
			matches: $("#matches"),
			comments: $("#comments"),
			addBlock: $("#add-block-container"),
			projectMembers: $("#project-members-container"),
		};

		this.IDT = {
			menuContainer: $("#IDT-menu-container"),
			menuItemsContainer: $("#IDT-menu-container > .menu-items-container"),
			// menuArrow: $('#IDT-menu-container > .arrow'),
			btn: $("#IDT-btn"),
			init: function () {
				this.menuContainer.on("click", ".menu-item", e => {
					e.stopPropagation();
					this.select($(e.currentTarget).data("index"));
				});
			},

			getIndexByName: function(name) {
				return luts.IDT.findIndex(IDT => IDT.label == name);
			},

			selectByName: async function(name) {
				const IDTindex = this.getIndexByName(name);
				await this.select(IDTindex);
			},

			select: async function(IDTindex) {
				this.menuContainer.addClass("hide");
				UI.state.menu.IDT = false;

				this.btn.find(".menu-label").html(luts.IDT[IDTindex].label);

				// Waiting for first IDT selection
				if (!lutify.selectedIDT) {
					lutify.afterInitialIDTselected(IDTindex);
					UI.enableImageTools(true);
				} else gpu.updateIDT(luts.IDT[IDTindex]);

				UI.toggleStartTips();

				UI.enableODT();
				lutify.updateImageThumbnail();
				await lutify.storeLastState();

				UI.toggleImageTools();

				// if (vm.$store.state.UI.startTips == 2.5) {
				// 	vm.$store.dispatch("UI/setStartTips", 3);
				// 	UI.container.addBlock.get(0)._tippy.show();
				// }

			},

			appendItems: function (items) {
				let elements = _utils.sortAlphabetically(items).map((item, i) => {
					let span = document.createElement("span");
					span.setAttribute("class", "menu-item");
					if (item.hidden) span.setAttribute("class", "menu-item hidden");
					span.setAttribute("data-index", i);
					// Make the "No Input Transform" appear first in the list
					if (item.label == "No Input Transform") span.setAttribute("class", "menu-item first");
					span.innerHTML = item.label;
					return span;
				});

				this.menuItemsContainer.append(elements);
			},
		};

		this.ODT = {
			menuContainer: $("#ODT-menu-container"),
			menuItemsContainer: $("#ODT-menu-container > .menu-items-container"),
			btn: $("#ODT-btn"),
			init: function () {
				this.menuContainer.on("click", ".menu-item", e => {
					e.stopPropagation();
					this.menuContainer.toggleClass("hide");
					UI.state.menu.ODT = false;
					let ODTindex = $(e.currentTarget).data("index");

					this.btn.find(".menu-label").html(e.currentTarget.innerHTML);
					gpu.updateODT(luts.ODT[ODTindex]);

					lutify.updateImageThumbnail();
					lutify.storeLastState();
				});
			},
			appendItems: function (items) {
				let elements = _utils.sortAlphabetically(items).map((item, i) => {
					let span = document.createElement("span");
					span.setAttribute("class", "menu-item");
					span.setAttribute("data-index", i);
					if (item.label == "No Output Transform") span.setAttribute("class", "menu-item first");
					span.innerHTML = item.label;
					return span;
				});

				this.menuItemsContainer.append(elements);
			},
		};

		this.lutPreviewThumbnail = {
			setSize: function (width, height) {
				$(".scene").css("width", width + "px");
				$(".scene").css("height", height + "px");
			},
		};

		this.btn = {
			showChanges: $(".show-changes"),
			hideChanges: $(".hide-changes"),
			closeScopesView: $("#btn-close-scopes"),

			importPreset: $("#btn-import-preset"),
			deletePresetFolder: $("#btn-delete-preset-folder"),
			addFolder_savePresetModal: $("#btn_modal-add-folder-save-preset"),
			addFolder_importPresetModal: $("#btn_modal-add-folder-import-preset"),

			addBlock: $("#btn-add-block"),
			magicMode: $("#btn-magic-mode"),
		};

		this.label = {
			imageBeforeLabel: $(".image-before-label"),
			hideImageBeforeLabel: function () {
				this.imageBeforeLabel.css("display", "none");
			},
			showImageBeforeLabel: function () {
				this.imageBeforeLabel.css("display", "inline-block");
			},
		};

		this.lutsPreviewCanvas = {
			el: document.getElementById("luts-preview-canvas"),
		};

		this.canvas = {
			self: this,
			el: gpu.renderer.domElement,
			$el: $(gpu.renderer.domElement),
			dpx: document.getElementById("dpx-canvas"),
			setSize: function (width, height) {
				this.el.width = width;
				this.el.height = height;
			},
			setSizeCSS: function () {
				let space = this.self.getAvailableMainSpace();
				this.$el.css("max-width", `${space.width}px`);
				this.$el.css("max-height", `${space.height}px`);
			},
		};

		this.exportCanvas = {
			el: gpu.exportRenderer.domElement,
			$el: $(gpu.exportRenderer.domElement),
			setSize: function (width, height) {
				this.el.width = width;
				this.el.height = height;
			},
		};

		this.colourMatchCanvas = {
			el: document.getElementById("colour-match-canvas"),
			$el: $("#colour-match-canvas"),
			setSize: function (width, height) {
				this.el.width = width;
				this.el.height = height;
			},
		};

		this.thumbnailCanvas = {
			el: document.getElementById("thumbnail-canvas"),
			$el: $("#thumbnail-canvas"),
			setSize: function (width, height) {
				this.el.width = width;
				this.el.height = height;
			},
		};

		this.modals = {
			newCompare: {
				el: $("#modal-new-compare"),
				btn: $("#modal-new-compare .btn"),
			},
			swapImage: {
				el: $("#swap-image-modal"),
			},
			resetScene: {
				el: $("#reset-scene-modal"),
			},
			customLUT: {
				importLuts: {
					el: $("#import-custom-luts-modal"),
				},
				edit: {
					el: $("#edit-custom-luts-modal"),
				},
				delete: {
					el: $("#delete-custom-lut-modal"),
				},
				rename: {
					el: $("#rename-custom-lut-modal"),
				},
				createFolder: {
					el: $("#create-custom-lut-folder-modal"),
				},
				renameFolder: {
					el: $("#rename-custom-lut-folder-modal"),
				},
				deleteFolder: {
					el: $("#delete-custom-luts-folder-modal"),
				},
			},
			customLutV2: {
				import: {
					el: $("#CustomLutV2-import-lut-modal"),
				},
				edit: {
					el: $("#CustomLutV2-edit-lut-modal"),
				},
				delete: {
					el: $("#CustomLutV2-delete-lut-modal"),
				},
				rename: {
					el: $("#CustomLutV2-rename-lut-modal"),
				},
				createFolder: {
					el: $("#CustomLutV2-create-lut-folder-modal"),
				},
				renameFolder: {
					el: $("#CustomLutV2-rename-lut-folder-modal"),
				},
				deleteFolder: {
					el: $("#CustomLutV2-delete-lut-folder-modal"),
				},
			},
			newMatch: {
				el: $("#modal-new-match"),
			},
			colorWorkflowNotification: {
				el: $("#color-workflow-notification-modal"),
			},
			colorWorkflowPresetNotification: {
				el: $("#color-workflow-preset-notification-modal"),
			},
			presets: {
				transformsMismatch: {
					el: $("#preset-transforms-mismatch-modal"),
				},
				import: {
					el: $("#import-preset-modal"),
				},
				import2: {
					el: $("#import-preset-2-modal"), // step 2 of import
				},
				save: {
					el: $("#save-preset-modal"),
				},
				delete: {
					el: $("#delete-preset-modal"),
				},
				deleteFolder: {
					el: $("#delete-preset-folder-modal"),
				},
				fileSupport: {
					el: $("#file-type-not-supported-modal"),
				},
				invalidFile: {
					el: $("#invalid-preset-file-modal"),
				},
			},
			customBlock: {
				save: {
					el: $("#save-custom-block-modal"),
				},
				delete: {
					el: $("#delete-custom-block-modal"),
				},
				rename: {
					el: $("#rename-custom-block-modal"),
				},
			},
			project: {
				selector: $("#project-selector-modal"),
				create: $("#modal-create-project"),
				rename: $("#modal-rename-project"),
				delete: $("#modal-delete-project"),
				assign: $("#modal-assign-project"),
			},
			bin: {
				create: $("#bin-create-modal"),
				edit: $("#bin-edit-modal"),
				delete: $("#bin-delete-modal"),
			},
			trashFolder: {
				empty: $("#trash-folder-empty-modal"),
			},
			files: {
				copyTo: $("#file-copy-to-modal"),
				failedProcessing: $("#failed-processing-modal"),
				failedUploading: $("#failed-uploading-modal"),
				copyCandidateFrom: $("#copy-candidate-from-modal"),
			},
			grade: {
				applyTo: $("#apply-grade-to-modal"),
				applyFrom: $("#apply-grade-from-modal"),
			},
			blocks: {
				warnings: {
					nonExportableTool: $("#non-exportable-tool-modal"),
					colourMatchTool: $("#colour-match-tool-notice")
				},
			},
			products: {
				purchase: $("#product-purchase-modal"),
			},
			colourMatch: {
				el: $("#colour-match-to-modal"),
			},
			colourMatchV2: {
				el: $("#colour-match-v2-to-modal"),
			},
			advancedColourMatchV2: {
				el: $("#advanced-colour-match-v2-to-modal"),
			},
			AIColourExtract: {
				el: $("#ai-colour-extract-from-modal"),
			},
			AIColourExtractV2: {
				el: $("#ai-colour-extract-v2-from-modal"),
			},
			AIColourMatch: {
				el: $("#ai-colour-match-from-modal"),
			},
			AIColourMatchV2: {
				el: $("#ai-colour-match-v2-from-modal"),
			},
			notAvailableInFree: {
				el: $("#not-available-in-free-modal"),
			},
			viewCommentUpload: {
				el: $("#view-comment-upload-modal")
			},
			whatsNew: {
				el: $("#whats-new-modal"),
			},
			compareView: {
				el: $("#compare-view-modal")
			},
			neuralToneAI: {
				processing: {
					el: $('#neural-tone-ai-processing-modal')
				},
				unprocessedList: {
					el: $('#neural-tone-ai-unprocessed-list-modal')
				}
			},
			neuralFilmAI: {
				processing: {
					el: $('#neural-film-ai-processing-modal')
				},
				unprocessedList: {
					el: $('#neural-film-ai-unprocessed-list-modal')
				}
			},

			saveAllAsCandidates: {
				processing: {
					el: $('#save-all-as-candidates-processing-modal')
				},
				unprocessedList: {
					el: $('#save-all-as-candidates-unprocessed-list-modal')
				}
			},
			errorWhileFetchingProjects: {
				el: $('#error-while-fetching-projects-modal')
			}
		};

		this.message = {
			bubble: $("#message_bubble"),
			text: $("#message_bubble > .bubble_text"),
			setText: function (text) {
				this.text.html(text);
			},
			activate: function (text = "", stay = false) {
				this.setText(text);
				this.bubble
					.css("display", "flex")
					.hide()
					.fadeIn(250, () => {
						if (!stay) setTimeout(() => this.deactivate(), 2000);
						else lutify.bubbleMessage = true;
					});
			},
			deactivate: function () {
				this.bubble.fadeOut(250);
			},
			texts: {
				inBeforeMode: "BEFORE view is active. Some changes are not visible. Press B to exit.",
			},
		};

		this.fullscreenMessage = {
			$el: $(".notification-container"),
			$text: $(".notification-container > .bubble_text"),
			create: function () {
				let container = document.createElement("div");
				container.setAttribute("class", "notification-container");

				let span = document.createElement("span");
				span.setAttribute("class", "bubble_text");

				container.appendChild(span);
				return container;
			},
			append: function (html) {
				UI.container.mainCanvases.append(html);
			},
			activate: function (text = "") {
				let html = this.create();
				html.querySelector(".bubble_text").innerHTML = text;
				this.append(html);
				$(html)
					.css("display", "flex")
					.hide()
					.fadeIn(500, () => {
						setTimeout(() => this.deactivate($(html)), 2000);
					});
			},
			deactivate: function ($html) {
				$html.fadeOut(500, _ => UI.container.mainCanvases.find(".notification").remove());
			},
		};

		this.lists = {
			looks: $("#looks-list"),
		};

		this.inputs = {
			nameLook: $("#name-look-input"),
			renameLook: $("#rename-look-input"),
			importPreset: $("#import-preset-input"),
		};

		this.progressBar = {
			initLoad: $(".loading-bar-home .progress-bar"),
			initLoadWrapper: $(".loading-bar-home"),
		};

		this.mouse = {
			x: null,
			y: null,
			down: null,
			lastX: null,
			lastY: null,
			knobDrag: false,
		};

		this.state = {
			menu: {
				IDT: false,
				ODT: false,
			},
		};

		this.tippy = null;

		this.roundSliderOptions = {
			radius: 8,
			width: 2,
			handleSize: -10,
			handleShape: "dot",
			sliderType: "min-range",
			value: 10,
			disabled: false,
		};

		this.tippy = {
			blocks: null,
		};

		this.nextModalToShow = null;

		this.scenePositionBuffer = null;
	}

	startApp() {
		if (!vm.$store.getters['User/isMemberOrLower'])	this.initLayouts();
		this.loadShortcutHandlers();

		this.IDT.appendItems(luts.IDT);
		this.ODT.appendItems(luts.ODT);

		this.IDT.init();
		this.ODT.init();

		this.container.sidebarSelector.removeClass("hide");
		this.container.appView.removeClass("init");
		if (config.testCurves.enabled) $("#curveSelect").fadeIn();

		UI.container.mainLayoutLeft.removeClass("hide");
		UI.container.imageTools.removeClass("hide");
		// UI.container.projectMembers.removeClass("invisible");
		// UI.container.previewsSidebarSelector.removeClass("invisible");
		// UI.container.previewsSidebarContainer.removeClass("invisible");
		UI.container.mainCanvases.find(".tools-container").removeClass("hide");
		UI.container.addBlock.removeClass("hide");

		this.disableImageTools();

		vm.$store.dispatch("UI/setUILoadedStatus", true);
		vm.$store.dispatch("UI/setStartTips", localStorage.getItem("startTips"));

		vm.$nextTick(() => {
			if (!localStorage.getItem('whats-new-2.2-opened', 1)) {
				vm.$store.dispatch('UI/setWhatsNewButtonAnimation');
			}
		})

		setInterval(async () => {
			if (this.mouse.x == this.mouse.lastX && this.mouse.y == this.mouse.lastY) return;
			if (!document.hasFocus()) return;

			this.mouse.lastX = this.mouse.x;
			this.mouse.lastY = this.mouse.y;

			if (!vm.$store.state.Projects.uploadStatus && vm.$route.name == 'app') {
				await vm.$store.dispatch("Projects/refreshProjectTree");
				// vm.$store.dispatch("Projects/fetchThumbnails");
			}
		}, 120000);
	}

	toggleStartTips() {
		if (lutify.getSelectedBlocksList().length == 0) {
			if (lutify.selectedIDT) {
				vm.$root.$refs.IDTButton.$el._tippy.hide();
				vm.$root.$refs.addControlButtonsContainer._tippy.show();
			} else {
				vm.$root.$refs.addControlButtonsContainer._tippy.hide();
				if (UI.state.menu.IDT) vm.$root.$refs.IDTButton.$el._tippy.hide();
				else vm.$root.$refs.IDTButton.$el._tippy.show();
			}
		} else {
			vm.$root.$refs.IDTButton.$el._tippy.hide();
			vm.$root.$refs.addControlButtonsContainer._tippy.hide();
		}
	}

	hideStartTips() {
		vm.$root.$refs.addControlButtonsContainer._tippy.hide();
		vm.$root.$refs.IDTButton.$el._tippy.hide();
	}

	projectSwitch() {
		this.container.mainCanvases.find(".tools-container").addClass("hide");
		this.container.mainLayoutMiddleBottomArea.addClass("hide");
		$("#wrapper").css("display", "none");
		this.disableImageTools();
	}

	toggleImageTools() {
		if (window.lutify.selectedIDT && !window.lutify.selectedIDT.initial) {
			window.UI.enableImageTools(true);
		} else {
			window.UI.disableImageTools();
			window.UI.enableImageTools();
		}

		vm.$store.dispatch("Projects/refreshProjectTree");
	}

	disableImageTools() {
		this.container.imageTools
			.find("span, i")
			.not("#btn-magic-mode")
			.addClass("--disabled");

		this.disableBlockAddingButtons();
	}

	disableBlockAddingButtons() {
		// this.container.imageTools.find("#btn-magic-mode").addClass("--disabled");
		this.container.addBlock.addClass("--disabled");
	}

	enableImageTools(blocks = false) {
		if (!lutify.selectedIDT || !lutify.selectedODT) {
			// this.container.imageTools.find("#btn-add-candidate").addClass('--disabled');
			// this.container.imageTools.find("#btn-save-match").addClass('--disabled');
		}

		if (blocks) {
			// this.container.addBlock.removeClass("--disabled");
		}
	}

	getAvailableMainSpace() {
		this.canvas.$el.hide();
		if (vm.$store.state.Scopes.scopesEnabled) this.container.scopes.css("display", "none");

		let containerWidth = this.container.main.width();
		let containerHeight = this.container.main.height();

		if (vm.$store.state.UI.filmstrip.active && vm.$store.state.UI.scopes) containerHeight -= vm.$store.state.UI.filmstrip.height;

		this.canvas.$el.show();
		if (vm.$store.state.Scopes.scopesEnabled) this.container.scopes.css("display", "flex");
		return { width: containerWidth, height: containerHeight };
	}

	async initLayouts() {
		await vm.$store.dispatch("UserFiles/fetchLayouts");
	}

	appendBlockLoadingSpinner($block) {
		let spinner = this.createLoadingSpinner();
		$block.find(".header-container .controls-wrapper").prepend(spinner);
		$block.find(spinner).roundSlider(this.roundSliderOptions);
	}

	createLoadingSpinner() {
		let spinner = document.createElement("i");
		spinner.setAttribute("class", "loading-spinner spin-animation");
		return spinner;
	}

	removeBlockLoadingSpinner($block) {
		$block.find(".header-container .loading-spinner").remove();
		$block.removeClass("disabled");
	}

	appendFileLoadingSpinner(file_id) {
		let $spinner = $(this.createLoadingSpinner()).roundSlider(this.roundSliderOptions);
		$(`#project-navigator-container .file[file_id="${file_id}"]`).prepend(
			$('<div class="loading-spinner-container"></div>').append($spinner)
		);
	}

	removeFileLoadingSpinner(file_id) {
		$(`#project-navigator-container [file_id="${file_id}"] .loading-spinner-container`).remove();
	}

	initTippy() {
		this.tippy = tippy("[data-tippy-content]", {
			delay: [400, null],
			// dynamicTitle: true,
			allowHTML: true,
		});

		this.initTippyBlocks();

		tippyDelegate("#content", {
			target: "[data-tippy-content]",
			delay: [400, null],
			placement: "bottom",
		});

		tippyDelegate("#load-preset-modal", {
			target: "[data-tippy-content]",
			delay: [400, null],
			placement: "top",
		});

		tippyDelegate("#members-avatar-list", {
			target: "[data-tippy-content]",
			delay: [400, null],
			placement: "top",
		});
	}

	initTippyBlocks() {
		this.tippy.blocks = tippyDelegate("#blocks-container", {
			target: "[data-tippy-content]",
			delay: [400, null],
		});
	}

	refreshTippyBlocks() {
		this.tippy.blocks[0].destroy();
		this.initTippyBlocks();
	}

	appendToLooksList(uniqueId, name) {
		let html = `<li class="look-list-item" data-look-id="${name}">
		<span class="custom-lut-title col-sm-10">${name}</span>
		<span class="custom-lut-controls col-sm-2">
		<span class="fas fa-pen rename-look-btn"></span>
		<span class="far fa-times-circle remove-look-btn"></span>
		</span>
		</li>`;
		this.lists.looks.append(html);
	}

	updateInitLoadProgressBar(percentage) {
		this.progressBar.initLoad.width(`${percentage}%`);
	}

	getWindowHeight() {
		return $(window).height();
	}

	hideMagicModeNav() {
		$("#magic-mode-nav-label").addClass("hide");
		$("#magic-mode-nav-container").addClass("hide");
	}

	expandBlock(block, animateExpand = true) {
		if (animateExpand)
			$(block)
				.find(".block_options")
				.slideDown(100);
		else
			$(block)
				.find(".block_options")
				.show();
		$(block)
			.find(".expand_options")
			.hide();
		$(block)
			.find(".collapse_options")
			.show();
	}

	collapseBlock(block) {
		$(block)
			.find(".block_options")
			.slideUp(50);
		$(block)
			.find(".collapse_options")
			.hide();
		$(block)
			.find(".expand_options")
			.show();
	}

	getAdjustmentBlock(blockNum) {
		return document.querySelector(`.adjustment-block[rel="block_${blockNum}"]`);
	}

	createAdjustmentBlockTemplate(adjustmentName, blockNum, data = {}) {
		let template = document.querySelector(`#template-${adjustmentName}`);
		let element = document.createElement("div");
		// let element = document.importNode(template.content, true);
		element.innerHTML = template.text;
		let controlsTemplate = document.querySelector("#template-block-controls");
		// let controlsElement = document.importNode(controlsTemplate.content, true);

		$(element)
			.find(".header-container")
			.append(controlsTemplate.text);
		// no blending mode for magic mode
		if (adjustmentName == "magic-mode") {
			$(element)
				.find(".blending-mode__label-container")
				.remove();
			$(element)
				.find(".blending-mode__items-container")
				.remove();
		}

		if ([
			'magic-mode',
			'ai-magic-mode',
			'ai-exposure',
			'ai-contrast',
			'ai-white-balance',
			'midtoneTexture',
			'gamut-compress',
			'technicolor-3-strip-process',
			'smart-warmth'
		].includes(adjustmentName)) {
			$(element)
				.find(".block-opacity__label-container")
				.remove();
			$(element)
				.find(".block-opacity__items-container")
				.remove();
		}

		element.querySelector(".adjustment-block").setAttribute("rel", `block_${blockNum}`);
		element.querySelector(".adjustment-block").setAttribute("origNum", blockNum);

		if (data.category) element.querySelector(".lookup_block_name").innerHTML = data.category;
		if (data.category) element.querySelector(".adjustment-block").setAttribute("data-category", data.category);
		if (data.control) element.querySelector(".adjustment-block").setAttribute("data-control", data.control);

		if (
			$(element)
				.children(".block_options")
				.children()
				.attr("id") == "curveManipulate"
		) {
			$(element)
				.children(".block_options")
				.children()
				.attr("id", "curveManipulate" + blockNum);
		}

		this.container.blocks.append(element.innerHTML);
		this.attachBlockEvents($(UI.getAdjustmentBlock(blockNum)));
		this.scrollToBlock(blockNum);
	}

	removeBlockBlendingModes($el) {
		$el.find(".blending-mode__label-container").remove();
		$el.find(".blending-mode__items-container").remove();
	}

	scrollToBlock(blockNum) {
		let blockOffsetTop = 0;
		let element = $("#blocks-container--outer");
		let block = element.find(`.adjustment-block[origNum="${blockNum}"]`);
		if (block.length > 0) blockOffsetTop = block.offset().top - 5;

		element.animate(
			{
				scrollTop: element.scrollTop() + (blockOffsetTop - element.offset().top),
			},
			200
		);
	}

	attachBlockEvents($element) {
		$element.on("click mousedown", e => {
			blocks.primaryBlockHandler($(e.target));

			// if (lutify.getActiveBlock() && lutify.getActiveBlock().name == "magicMode") {
			// 	vm.$store.dispatch("UI/setFilmstrip", false);
			// } else vm.$store.dispatch("UI/setFilmstrip", true);
		});

		$element.find(".header-container .name").on("dblclick", function () {
			if ($element.find(".collapse_options").is(":visible")) {
				$element.find(".collapse_options").trigger("click");
			} else {
				$element.find(".expand_options").trigger("click");
			}
		});

		$element.find(".block-opacity__label-container").on("click", e => {
			e.stopPropagation();
			let itemsContainer = $(e.currentTarget).siblings(".block-opacity__items-container");
			if (itemsContainer.is(":visible")) itemsContainer.hide();
			else itemsContainer.show();
		});

		$element.find(".blending-mode__label-container").on("click", e => {
			e.stopPropagation();
			let itemsContainer = $(e.currentTarget).siblings(".blending-mode__items-container");
			if (itemsContainer.is(":visible")) itemsContainer.hide();
			else itemsContainer.show();
		});

		$element.find(".blending-mode__items-container > span").on("click", e => {
			lutify.tempSelectedBlendingMode = null;
			blocks.updateBlendingMode(e.currentTarget.dataset.id);
			lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = true));
			lutify.getActiveBlock().blendingMode = e.currentTarget.dataset.id;
			lutify.getActiveBlock().blendingModeName = e.currentTarget.innerHTML;
			blocks.checkSwitchHandler($element);

			$element.find(".blending-mode__items-container").hide();
			$element.find(".blending-mode__label-container .btn-blending-mode").attr("data-tippy-content", e.currentTarget.innerHTML);

			$element.find(".blending-mode__items-container > span").removeClass("--applied");
			$(e.currentTarget).addClass("--applied");

			if (e.currentTarget.dataset.id !== "0") $element.find(".blending-mode__label-container .btn-blending-mode").addClass("--applied");
			else {
				$element.find(".blending-mode__label-container .btn-blending-mode").removeClass("--applied");
				$element.find(".blending-mode__label-container .btn-blending-mode").attr("data-tippy-content", "Blending Mode");
			}
			this.refreshTippyBlocks();
		});

		$element.find(".blending-mode__items-container > span").on("mouseover", e => {
			lutify.tempSelectedBlendingMode = e.currentTarget.dataset.id;
			lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = true));
			blocks.checkSwitchHandler($element, false);
			blocks.updateBlendingMode(e.currentTarget.dataset.id);
		});

		$element.find(".blending-mode__items-container").on("mouseout", e => {
			if (lutify.tempSelectedBlendingMode) {
				if (lutify.getActiveBlock().blendingMode) blocks.updateBlendingMode(lutify.getActiveBlock().blendingMode);
				else blocks.updateBlendingMode(0);
			}

			lutify.tempSelectedBlendingMode = null;
		});
		$element.find(".controls-wrapper .switch > input").on("change", e => {
			e.stopImmediatePropagation();
			blocks.switchHandler($(e.target));
		});

		$element.on("click", ".collapse_options", e => {
			this.collapseBlock($(e.target).closest(".adjustment-block"));

			let activeBlock = lutify.getActiveBlock();
			if (activeBlock) {
				activeBlock.expanded = false;
			}
		});

		$element.on("click", ".expand_options", (e, animateExpand) => {
			this.expandBlock($(e.target).closest(".adjustment-block"), animateExpand);

			let activeBlock = lutify.getActiveBlock();
			if (activeBlock) {
				activeBlock.expanded = true;
			}
		});
		$element.on("click", ".btn-remove-block", e => {
			e.stopPropagation();
			blocks.removeBlock($(e.target).closest(".adjustment-block"));
			setTimeout(() => {
				lutify.storeLastState();
			}, 1000);
		});

		$element.on("click.reset", ".btn-reset-block", e => blocks.resetBlock($(e.target).closest(".adjustment-block")));
		$element.on("dblclick.reset", ".range_slider ", e => blocks.resetBlock($(e.target).closest(".adjustment-block"), $(e.currentTarget)));

		$element.on('input', '.header-container .opacity_slider', e => {
			let opacityValue = $(e.currentTarget).val();
			if (opacityValue == 100) {
				$element.find('.btn-block-opacity').removeClass('--applied');
			} else {
				$element.find('.btn-block-opacity').addClass('--applied');
			}
		})
	}

	createBlockCanvas(canvasName, blockNum) {
		let canvasElement = document.createElement("canvas");
		canvasName = `${canvasName}-${blockNum - config.endFixedPasses}`;
		canvasElement.setAttribute("data-id", canvasName);
		canvasElement.setAttribute("class", "rgbCurves curvesRGB curve");
		canvasElement.setAttribute("width", 256);
		canvasElement.setAttribute("height", 256);

		let canvasContainer = document.createElement("div");
		canvasContainer.setAttribute("data-name", canvasName);
		canvasContainer.setAttribute("class", "canvas-container");
		canvasContainer.append(canvasElement);
		$("#blocks-canvas-container").append(canvasContainer);

		if (config.testCurves.enabled) {
			let selectCanvasElement = document.createElement("option");
			selectCanvasElement.setAttribute("value", canvasName);
			selectCanvasElement.innerHTML = canvasName;
			$("#curveSelect").append(selectCanvasElement);
		}

		return canvasName;
	}

	getAdjustmentBlock_sliderValue($el, order = 0) {
		return parseFloat(
			$el
				.find(".adjustmentBlock-slider")
				.eq(order)
				.val()
		);
	}

	setAdjustmentBlock_sliderValue($el, value, order = 0) {
		$el
			.find(".adjustmentBlock-slider")
			.eq(order)
			.val(value);
	}

	getAdjustmentBlock_rangeValue($el, order = 0) {
		return parseFloat(
			$el
				.find(".adjustmentBlock-range")
				.eq(order)
				.val()
		);
	}

	setAdjustmentBlock_rangeValue($el, value, order = 0) {
		$el
			.find(".adjustmentBlock-range")
			.eq(order)
			.val(value);
	}

	getActiveBlock() {
		return $("#blocks-container > .selected_block");
	}

	selectPreview($element) {
		$(".preview-opacity-container").hide();
		$element.find(".preview-opacity-container").show();

		if (!$element.find(".scene").hasClass("selected_thumbnail")) {
			$("#previews-list-container .selected_thumbnail").removeClass("selected_thumbnail");
			$element.find(".scene").addClass("selected_thumbnail");
		}
	}

	deselectPreview() {
		$("#previews-list-container .scene").removeClass("selected_thumbnail");
		$(".preview-opacity-container").hide();
	}

	scrollToSelectedPreview(selectedPreview = false) {
		// only scroll when selecting a block, don't scroll when doing before/after on canvas
		if (!lutify.canvasMouseDown) {
			let selectedPreviewPosition = 0;
			if (selectedPreview) {
				selectedPreviewPosition = this.container.lutPreviews.scrollTop() + ($(selectedPreview).offset().top - this.container.lutPreviews.offset().top);
			}
			$("#previews-list-container").scrollTop(selectedPreviewPosition);
		}

		vm.$nextTick(() => {
			const interval = setInterval(() => {
				lutPreviewer.render()
			}, 10)

			setTimeout(() => {
				clearInterval(interval);
			}, 50)
		})
	}

	setPreviewerOpacity(opacityValue) {
		let element = $("#previews-list-container .selected_thumbnail").closest(".list-item");
		element.find(".thumbnail-slider").val(opacityValue);
		element.find(".thumbnail_range").val(opacityValue);
	}

	getBlock(blockNumber) {
		return $(`#blocks-container > .block[rel="block_${blockNumber}"]`);
	}

	removeBlock($block) {
		$block.remove();
	}

	enabledBlockSwitch() {
		if (
			!UI.getActiveBlock()
				.find(".controls-wrapper .switch > input")
				.is(":checked")
		) {
			UI.getActiveBlock()
				.find(".controls-wrapper .switch > input")
				.prop("checked", true);
			UI.getActiveBlock()
				.find(".controls-wrapper .switch > input")
				.trigger("change");
		}
	}

	hideLUTtemplates() {
		$("#lut-previews-container").addClass("hide");
		lutPreviewer?.renderer?.clear();
		vm.$store.dispatch('UI/setPreviewBasedBlock', false);
		// $('#previews-list-container').addClass('hide');
		// $('#luts-preview-canvas').addClass('hide');
	}

	removeBlockCanvas(blockCanvasName) {
		$(`[data-id="${blockCanvasName}"]`)
			.parent()
			.remove();
		if (config.testCurves.enabled) {
			$(`#curveSelect > option[value="${blockCanvasName}"]`).remove();
			$(`#curveSelect`).val("default");
		}
	}

	togglePreviewsContainer() {
		if (vm.$store.getters['User/isGuest']) return;
		if (lutify.getActiveBlock()?.collapsedPreviews) {
			vm.$store.dispatch('UI/setShowLutPreviews', false);
			return;
		}

		$("#lut-previews-container").removeClass("hide");
		this.paneResized();
		// $('#previews-list-container').removeClass('hide');
		$("#luts-preview-canvas").removeClass("hide");
		this.updatePreviewsTab();
		vm.$store.dispatch('UI/setShowLutPreviews', true);
	}

	updatePreviewsTab(label = lutify.selectedPreviewCategory) {
		$("#lut-preview-tab-title").html(label);
	}

	updateSelectedPreview(composerIndex = null) {
		if (composerIndex !== null) {
			let selectedPreview = $(`#previews-list-container .list-item[data-composer-index="${composerIndex}"]`);
			this.selectPreview(selectedPreview);
			vm.$nextTick(() => {
				this.scrollToSelectedPreview(selectedPreview)
			})
		} else {
			this.deselectPreview();
			vm.$nextTick(() => {
				this.scrollToSelectedPreview()
			})
		}
	}

	refreshScene() {
		gpu.renderer.setSize(lutify.imageWidth, lutify.imageHeight, false);
		gpu.render();

		this.canvas.setSizeCSS();
		lutPreviewer.setSize();

		this.lutPreviewThumbnail.setSize(lutPreviewer.width, lutPreviewer.height);
		lutPreviewer.render();

	}

	rotateScene() {
		if (!vm.$store.state.Projects.image) return;
		this.rotateMainCanvas("90deg");
		this.rotatePreviews(lutify.rotation);

		this.refreshScene();

		if (lutify.splitViewActive) lutify.refreshSplitView();
	}

	rotateMainCanvas(angle) {
		let oldRotation = lutify.rotation;
		let newRotation = oldRotation + parseInt(angle);
		let rotateStep;

		if (newRotation == 360) newRotation = 0;

		if (newRotation == 0 || newRotation == 180) {
			// lutify.imageWidth = loader.img.width;
			// lutify.imageHeight = loader.img.height;
			lutify.imageWidth = lutify.activeImageWidth;
			lutify.imageHeight = lutify.activeImageHeight;
		} else {
			// lutify.imageWidth = loader.img.height;
			// lutify.imageHeight = loader.img.width;
			lutify.imageWidth = lutify.activeImageHeight;
			lutify.imageHeight = lutify.activeImageWidth;
		}

		switch (newRotation) {
			case 0:
				rotateStep = 0;
				break;
			case 90:
				rotateStep = 1;
				break;
			case 180:
				rotateStep = 2;
				break;
			default:
				rotateStep = 3;
		}

		let texture = gpu.mesh.material.map;
		texture.center.set(0.5, 0.5);
		texture.rotation = -((Math.PI / 2) * rotateStep);
		lutify.rotation = newRotation;
	}

	rotatePreviews(angle) {
		let rotateStep;

		switch (angle) {
			case 0:
				rotateStep = 0;
				break;
			case 90:
				rotateStep = 1;
				break;
			case 180:
				rotateStep = 2;
				break;
			default:
				rotateStep = 3;
		}

		lutPreviewer.composers.forEach((composer, i) => {
			if (composer == "empty") return;

			try {
				if (composer.passes.length) {
					let texture = composer.passes[0].scene.children[0].material.map;
					texture.center.set(0.5, 0.5);
					texture.rotation = -((Math.PI / 2) * rotateStep);
				}
			} catch (error) {
				console.log(error);
			}
		});
	}

	rotateCanvasToInit() {
		this.canvas.$el.css("transform", "rotate(0deg)");
	}

	loadShortcutHandlers() {
		$("body").on("keydown", function (key) {
			// console.log(key);
			// console.log(key.key, key.keyCode);
			if (vm.$store.state.App.blockLoading) return;
			if (vm.$route.matched.find(match => match.path == "/account")) return; // disable in account pages
			if (["file-rename", "bin-rename"].includes(vm.$store.state.Projects.action.action)) return;

			if (lutify.activeModal) {
				if (key.key == "Escape" || key.keyCode == 27) {
					if ($(lutify.activeModal).hasClass("modal-new")) {
						$(lutify.activeModal)
							.find(".btn-close-modal")
							.trigger("click");
					}
				} else if (key.key == "Enter" || key.keyCode == 13) {
					if ($(lutify.activeModal).hasClass("modal-new")) {
						$(lutify.activeModal)
							.find(".modal-btn.--primary")
							.trigger("click");
					}
				}
			}

            // Custom lut block - when input or output color space container is open
            else if ((UI.getActiveBlock().find('.input-color-space-selector__items-container').get(0) && UI.getActiveBlock().find('.input-color-space-selector__items-container').prop('style').display === '') ||
                (UI.getActiveBlock().find('.output-color-space-selector__items-container').get(0) && UI.getActiveBlock().find('.output-color-space-selector__items-container').prop('style').display === '')) {
                let targetContainer;
                let targetContainerClass;
                if (UI.getActiveBlock().find('.input-color-space-selector__items-container').prop('style').display === '') {
                    targetContainer = UI.getActiveBlock().find('.input-color-space-selector__items-container').get(0);
                    targetContainerClass = '.input-color-space-selector__items-container';
                }
                else if (UI.getActiveBlock().find('.output-color-space-selector__items-container').prop('style').display === '') {
                    targetContainer = UI.getActiveBlock().find('.output-color-space-selector__items-container').get(0);
                    targetContainerClass = '.output-color-space-selector__items-container';
                }

                let firstLetterList = [];
                Array.from(
                    targetContainer.querySelectorAll('span')
                ).forEach(item => firstLetterList.push(item.innerHTML.slice(0, 1)));

                let firstLetterIndex = firstLetterList.findIndex(item => item.toLowerCase() == key.key);
                if (firstLetterIndex == -1) return;

                let targetElement = targetContainer.querySelectorAll('span')[
                    firstLetterIndex
                    ];

                UI.getActiveBlock().get(0).querySelector(targetContainerClass).scrollTop =
                    targetElement.offsetTop;
            }

			// when file options IDT ODT is opened in project tree
			else if (
				document.querySelector(".file-options-container.--IDT.menuable__content__active") ||
				document.querySelector(".file-options-container.--ODT.menuable__content__active")
			) {
				let container;
				if (document.querySelector(".file-options-container.--IDT.menuable__content__active")) container = "--IDT";
				else if (document.querySelector(".file-options-container.--ODT.menuable__content__active")) container = "--ODT";

				let firstLetterList = [];
				Array.from(
					document.querySelectorAll(`.file-options-container.${container}.menuable__content__active .v-list-item__title`)
				).forEach(item => firstLetterList.push(item.innerHTML.slice(0, 1)));

				let firstLetterIndex = firstLetterList.findIndex(item => item.toLowerCase() == key.key);
				if (firstLetterIndex == -1) return;

				let targetElement = document.querySelectorAll(`.file-options-container.${container}.menuable__content__active .v-list-item`)[
					firstLetterIndex
					];

				document.querySelector(`.file-options-container.${container}.menuable__content__active .v-list`).scrollTop =
					targetElement.offsetTop;
			}

			// when IDT ODT modal open
			else if (UI.state.menu.IDT || UI.state.menu.ODT) {
				if (UI.state.menu.IDT) {
					let firstLetterList = [];
					UI.IDT.menuContainer.find(".menu-item:not(.hidden)").map((key, item) => {
						firstLetterList.push($(item).html().charAt(0))
					});
					let firstLetterIndex = firstLetterList.findIndex(item => item.toLowerCase() == key.key);

					if (firstLetterIndex == -1) return;

					let targetElement = UI.IDT.menuItemsContainer.find(`.menu-item:not(.hidden)`).eq(firstLetterIndex);
					$('#IDT-menu-container').scrollTop(
						$('#IDT-menu-container').scrollTop() + (targetElement.offset().top - $('#IDT-menu-container').offset().top)
					);
				} else if (UI.state.menu.ODT) {
					let firstLetterList = [];
					UI.ODT.menuContainer.find(".menu-item:not(.hidden)").map((key, item) => {
						firstLetterList.push($(item).html().charAt(0))
					});
					let firstLetterIndex = firstLetterList.findIndex(item => item.toLowerCase() == key.key);

					if (firstLetterIndex == -1) return;

					let targetElement = UI.ODT.menuItemsContainer.find(`.menu-item:not(.hidden)`).eq(firstLetterIndex);
					$('#ODT-menu-container').scrollTop(
						$('#ODT-menu-container').scrollTop() + (targetElement.offset().top - $('#ODT-menu-container').offset().top)
					);
				}
			}

			// When modal not active
			else {
				if (window.vm.$root.commentsEditor.quill.hasFocus()) return;

				if (
					$("#project-tree-search-input")
						.closest(".v-input")
						.hasClass("v-input--is-focused")
				)
					return;

				if (
					$("#candidate-search-input")
						.closest(".v-input")
						.hasClass("v-input--is-focused")
				)
					return;

				if (
					$("#match-search-input")
						.closest(".v-input")
						.hasClass("v-input--is-focused")
				)
					return;

				if ($('.v-input').hasClass('v-input--is-focused')) return;

				if (lutify.getActiveBlock() && lutify.getActiveBlock().name == "magicMode") {
					// Magic mode
					if (key.key == "ArrowLeft" || key.keyCode == 37) {
						key.preventDefault();
						_Adjustments.magicMode.navArrowHandler("prev");
					} else if (key.key == "ArrowRight" || key.keyCode == 39) {
						key.preventDefault();
						_Adjustments.magicMode.navArrowHandler("next");
					}
				}

				if (lutify.getActiveBlock() && lutify.getActiveBlock().name == "AIMagicMode") {
					// AI Magic mode
					if (key.key == "ArrowLeft" || key.keyCode == 37) {
						key.preventDefault();
						_Adjustments.AIMagicMode.navArrowHandler("prev");
					} else if (key.key == "ArrowRight" || key.keyCode == 39) {
						key.preventDefault();
						_Adjustments.AIMagicMode.navArrowHandler("next");
					}
				}

				// LUT previews
				if (UI.getActiveBlock().hasClass("preview-based") && lutify.activeSidebarContainer !== "project" && !UI.getActiveBlock().find('input[type="number"]').is(":focus")) {
					if (key.key == "ArrowDown" || key.keyCode == 40) {
						key.preventDefault();

						let $previews = $("#previews-list-container").find("> .list-item:visible");
						let firstPreview = $previews.eq(0);

						if ($previews.find(".selected_thumbnail").length == 0) {
							firstPreview.trigger("click");
							UI.scrollToSelectedPreview();
						} else UI.selectNextPreview();
					} else if (key.key == "ArrowUp" || key.keyCode == 38) {
						key.preventDefault();
						UI.selectPrevPreview();
					} else if (key.key == "Enter" || key.keyCode == 13) {
						key.preventDefault();
						let $previews = $("#previews-list-container").find("> .list-item:visible");
						let firstPreview = $previews.eq(0);

						if ($previews.find(".selected_thumbnail").length == 0) {
							firstPreview.trigger("click");
							UI.scrollToSelectedPreview();
						} else $previews.find(".selected_thumbnail").trigger("click");
					}
				}

				// Project navigator
				// if (lutify.activeSidebarContainer == "project") {
				// 	if (key.key == "ArrowDown" || key.keyCode == 40) {
				// 		key.preventDefault();
				// 		UI.selectNextImage(vm.$store.state.Projects.image);
				// 	} else if (key.key == "ArrowUp" || key.keyCode == 38) {
				// 		key.preventDefault();
				// 		UI.selectPreviousImage(vm.$store.state.Projects.image);
				// 	}
				// }

				// Shift keys
				if (key.shiftKey) {
					if (key.key === "c" || key.keyCode == 67) vm.$root.$refs.addCandidateButton.$el.click();
					else if (key.key === "m" || key.keyCode == 77) vm.$root.$refs.addMatchButton.$el.click();
					else if (key.key === "s" || key.keyCode == 83) vm.$root.$refs.savePresetButton.$el.click();
					else if (key.key === "l" || key.keyCode == 76) vm.$root.$refs.showPresetsButton.$el.click();
					else if (key.key === "d" || key.keyCode == 68) vm.$root.$refs.downloadLUTButton.$el.click();
					else if (key.key === "i" || key.keyCode == 73) vm.$root.$refs.downloadImageButton.$el.click();
				}

				// Normal keys
				else {
					if (key.key === "s" || key.keyCode == 83) {
						if (!vm.$store.state.Scopes.scopesEnabled) vm.$root.$refs.scopesButton.$el.click();
						else UI.btn.closeScopesView.trigger("click");
					} else if (key.key === "b" || key.keyCode == 72) {
						if (!lutify.activeBefore) lutify.hideBlockSelections();
						else lutify.showBlockSelections();
					} else if (key.key === "f" || key.keyCode == 70) {
						if (!lutify.fullscreen) UI.enterFullscreen();
						else UI.exitFullscreen();
					} else if (key.key === "r" || key.keyCode == 82) UI.rotateScene();
					else if (key.key === "x" || key.keyCode == 88) vm.$root.$refs.resetSceneButton.$el.click();
					else if (key.key === "v" || key.keyCode == 86) {
						if (lutify.splitViewActive === false) {
							lutify.setSplitView();
							vm.$store.dispatch('UI/setSplitView', true);
						} else {
							lutify.removeSplitView();
							vm.$store.dispatch('UI/setSplitView', false);
						}
					} else if (key.key === "m" || key.keyCode == 77) vm.$root.$refs.addMagicModeButton.$el.click();
					// else if (key.key === "a" || key.keyCode == 65) vm.$root.$refs.addBlockButton.$el.click();
					else if (key.key == "Escape" || key.keyCode == 27) {
						if (lutify.activeSemiFullscree) UI.exitSemiFullscreen();
					}
					// else if ((key.key === "1" || key.keyCode == 49) && key.target.nodeName !== "INPUT")
					// 	// UI.container.sidebarSelector.find('[data-container="project"]').trigger("click");
					// else if ((key.key === "2" || key.keyCode == 50) && key.target.nodeName !== "INPUT")
					// 	// UI.container.sidebarSelector.find('[data-container="blocks"]').trigger("click");
					// else if ((key.key === "3" || key.keyCode == 51) && key.target.nodeName !== "INPUT")
					// 	// UI.container.sidebarSelector.find('[data-container="compares"]').trigger("click");
					// else if ((key.key === "4" || key.keyCode == 52) && key.target.nodeName !== "INPUT")
					// 	// UI.container.previewsSidebarSelector.find('[data-container="previews"]').trigger("click");
					// else if ((key.key === "5" || key.keyCode == 53) && key.target.nodeName !== "INPUT")
					// 	// UI.container.previewsSidebarSelector.find('[data-container="matches"]').trigger("click");
					// else if ((key.key === "6" || key.keyCode == 54) && key.target.nodeName !== "INPUT")
					// 	// UI.container.previewsSidebarSelector.find('[data-container="comments"]').trigger("click");
				}
			}
		});
	}

	selectNextImage(id) {
		let nextImage = $("#project-navigator-container")
			.find(`[file_id="${id}"]`)
			.closest(".v-treeview-node--leaf")
			.nextAll(".v-treeview-node--leaf:first")
			.find(".file-name");

		if (nextImage.length > 0) {
			nextImage.trigger("click");
			return true;
		} else return false;
	}

	selectPreviousImage(id) {
		let previousImage = $("#project-navigator-container")
			.find(`[file_id="${id}"]`)
			.closest(".v-treeview-node--leaf")
			.prevAll(".v-treeview-node--leaf:first")
			.find(".file-name");

		if (previousImage.length > 0) {
			previousImage.trigger("click");
			return true;
		} else return false;
	}

	selectNextPreview() {
		if ($(".selected_thumbnail").length == 0) return;

		let currentThumbnail = $(".selected_thumbnail").closest('.list-item[data-category="' + lutify.selectedPreviewCategory + '"]');
		let nextItem = $(currentThumbnail).next(".list-item");

		if (nextItem.attr("data-category") == lutify.selectedPreviewCategory) {
			$(currentThumbnail)
				.find(".selected_thumbnail")
				.removeClass("selected_thumbnail");
			nextItem.trigger("click");
			UI.container.lutPreviews.animate(
				{ scrollTop: UI.container.lutPreviews.scrollTop() + (nextItem.offset().top - UI.container.lutPreviews.offset().top) },
				200
			);
		}
	}

	selectPrevPreview() {
		if ($(".selected_thumbnail").length == 0) return;

		let currentThumbnail = $(".selected_thumbnail").closest('.list-item[data-category="' + lutify.selectedPreviewCategory + '"]');
		let previousItem = $(currentThumbnail).prev(".list-item");

		if (previousItem.attr("data-category") == lutify.selectedPreviewCategory) {
			$(currentThumbnail)
				.find(".selected_thumbnail")
				.removeClass("selected_thumbnail");
			previousItem.trigger("click");
			UI.container.lutPreviews.animate(
				{ scrollTop: UI.container.lutPreviews.scrollTop() + (previousItem.offset().top - UI.container.lutPreviews.offset().top) },
				200
			);
		}
	}

	async appendToMatches(matchData, message = true) {
		matchData.bin_name = vm.$store.getters["Projects/binNameById"](matchData.bin_id);
		await vm.$store.dispatch("UI/addMatch", matchData);
		if (message) {
			this.message.activate("Match added successfully");
			vm.$store.dispatch('UI/setAnimationForAddingMatch');
		}
	}

	async appendToCandidates(candidate, notify = true) {
		let thumbnail = await thumbnailsStore.getItem(candidate.id);
		await vm.$store.dispatch("UI/addCandidate", { ...candidate, thumbnailBlob: thumbnail.blob });

		if (notify) {
			this.message.activate("Candidate Saved Successfully");
			vm.$store.dispatch('UI/setAnimationForAddingCandidate');
		};
	}

	showModal(modal, nextModalToShow = null, forceClose = false) {
		if (lutify.activeModal == this.modals.compareView.el) return; // don't allow any other modal to be displayed while compare view is open
		if (modal == this.modals.neuralToneAI.processing.el) vm.$root.neuralToneAIProcessingModal.startAnimation();
		if (modal == this.modals.neuralFilmAI.processing.el) vm.$root.neuralFilmAIProcessingModal.startAnimation();

		this.hideModal(lutify.activeModal, forceClose);
		UI.container.appView.addClass("overlay");
		modal.removeClass("hidden invisible");
		modal.addClass("fadeInDownModal");
		modal.find('input[type="text"]').val("");
		setTimeout(_ => modal.find('input[type="text"]').focus(), 100);
		lutify.activeModal = modal;
		this.nextModalToShow = nextModalToShow;
	}

	showModalWithoutClearing(modal, nextModalToShow = null) {
		UI.container.appView.addClass("overlay");
		modal.removeClass("hidden invisible");
		modal.addClass("fadeInDownModal");
		setTimeout(_ => modal.find('input[type="text"]').focus(), 100);
		lutify.activeModal = modal;
		this.nextModalToShow = nextModalToShow;
	}

	hideModal(modal = lutify.activeModal, forceClose = false) {
		if (lutify.activeModal == this.modals.compareView.el && !forceClose && !lutify.activeSecondLevelModal) return; // don't allow any other modal to be displayed while compare view is open

		if (!modal) return;
		if (lutify.activeSecondLevelModal) {
			this.hideSecondLevelModal(lutify.activeSecondLevelModal);
			return;
		}

		if (modal == this.modals.neuralToneAI.processing.el) vm.$root.neuralToneAIProcessingModal.stopAnimation();
		if (modal == this.modals.neuralFilmAI.processing.el) vm.$root.neuralFilmAIProcessingModal.stopAnimation();

		UI.container.appView.removeClass("overlay");
		$(modal).addClass("hidden invisible");
		$(modal).removeClass("fadeInDownModal");
		lutify.activeModal = null;
		if (this.nextModalToShow) {
			this.showModal(this.nextModalToShow);
			this.nextModalToShow = null;
		}
	}

	async showSecondLevelModal(modal, firstLevelModal = null) {
		if (firstLevelModal || lutify.activeModal) lutify.activeModal.addClass('--first-level-modal');

		await new Promise(resolve => {
			setTimeout(() => {
				resolve()
			}, 100)
		})

		modal.removeClass("hidden invisible");
		modal.addClass("fadeInDownModal --second-level-modal");
		modal.find('input[type="text"]').val("");
		setTimeout(_ => modal.find('input[type="text"]').focus(), 100);
		lutify.activeSecondLevelModal = modal;
	}

	hideSecondLevelModal(modal = lutify.activeSecondLevelModal) {
		if (!modal) return;
		if (lutify.activeModal) lutify.activeModal.removeClass('--first-level-modal');
		$(modal).addClass("hidden invisible");
		$(modal).removeClass("fadeInDownModal --second-level-modal");
		lutify.activeSecondLevelModal = null;
	}

	getPreviewDescription(composerIndex) {
		return $(`#previews-list-container .list-item[data-composer-index="${composerIndex}"]`)
			.find(".description")
			.html();
	}

	createLutDropdownList(luts) {
		let list = "";
		luts.forEach(lut => {
			list += `<span data-composer-index="${lut.composerIndex}">${lut.title}</span>`;
		});
		return list;
	}

	showScopes() {
		UI.canvas.setSizeCSS();
		gpu.render(); // fix for Safari

		UI.container.mainLayoutMiddleBottomArea.animate(
			{ bottom: "-100%", opacity: 0 },
			{
				duration: 250,
				complete: function () {
					UI.container.mainLayoutMiddleBottomArea.addClass("hide");
					UI.container.imageTools.addClass("hide");
					UI.container.status.addClass("hide");
					UI.container.mainLayoutMiddle.addClass("--scopes-view");
					UI.container.main.addClass("--scopes-view");
					UI.container.scopes.removeClass("hide");
					vm.$store.dispatch("UI/setScopes", true);
					vm.$store.dispatch("UI/setFilmstrip", false);
					UI.container.scopes.animate({ bottom: "0", opacity: 1 }, { duration: 250 });
				},
			}
		);

		UI.container.imageTools.animate({ bottom: "-100%", opacity: 0 }, { duration: 250 });
		UI.container.status.animate({ top: "-100%", opacity: 0 }, { duration: 250 });
	}

	hideScopes() {
		UI.canvas.setSizeCSS();

		UI.container.scopes.animate(
			{ bottom: "-100%", opacity: 0 },
			{
				duration: 250,
				complete: function () {
					UI.container.mainLayoutMiddleBottomArea.removeClass("hide");
					UI.container.imageTools.removeClass("hide");
					UI.container.status.removeClass("hide");
					UI.container.scopes.addClass("hide");
					UI.container.mainLayoutMiddle.removeClass("--scopes-view");
					UI.container.main.removeClass("--scopes-view");
					vm.$store.dispatch("UI/setScopes", false);
					vm.$store.dispatch("UI/setFilmstrip", true);

					UI.container.imageTools.animate({ bottom: "0", opacity: 1 }, { duration: 250 });
					UI.container.mainLayoutMiddleBottomArea.animate({ bottom: "0", opacity: 1 }, { duration: 250 });
					UI.container.status.animate({ top: "0", opacity: 1 }, { duration: 250 });
				},
			}
		);
	}

	showSwapImageModal() {
		return new Promise((resolve, reject) => {
			this.showModal(this.modals.swapImage.el);

			// swap image - keep changes
			$('.modal-btn[data-modal-action="keep-changes"]')
				.off("click")
				.on("click", function () {
					resolve("swap");
				});

			// Open new image - start from scratch
			$('.modal-btn[data-modal-action="start-from-scratch"]')
				.off("click")
				.on("click", function () {
					resolve("reset");
				});
		});
	}

	setUIToInitial() {
		lutify.selectedPreviewCategory = null;
		lutify.splitViewActive = false;
		lutify.splitSlider = 0.5;
		lutify.rotation = 0;

		lutify.removeSplitView();
		UI.rotateCanvasToInit();
		UI.disableBlockAddingButtons();

		$(".selected_block").removeClass("selected_block");
		$(".selected_thumbnail").removeClass("selected_thumbnail");
		$(".thumbnail-canvas:visible").hide();
	}

	showFileNotSupported() {
		$(".loader").fadeOut();
		$(".not-supported-msg").remove();
		$("body").append('<p class="not-supported-msg">File type not supported</p>');
		setTimeout(_ => $(".not-supported-msg").fadeOut(), 7000);
	}

	showImageLoader(aboveCanvas = false) {
		this.hideImageLoader();

		if (!aboveCanvas) {
			this.container.mainCanvases.find(".tools-container").addClass("hide");
			this.canvas.$el.css("visibility", "hidden");
		}

		this.createImageLoader(aboveCanvas);
	}

	createImageLoader(aboveCanvas = false) {
		let container = document.createElement('div');
		container.classList.add('loader-container');
		if (aboveCanvas) container.classList.add('above-canvas');

		let span = document.createElement('span');
		span.classList.add('loader');

		container.append(span);

		UI.container.main.append(container);
	}

	hideImageLoader() {
		this.container.main.find(".loader-container").remove();
		this.container.mainCanvases.find(".tools-container").removeClass("hide");
		this.canvas.$el.css("visibility", "initial");
	}

	enterFullscreen() {
		let container = UI.container.mainCanvases[0];
		let rFS =
			container.mozRequestFullScreen || container.webkitRequestFullscreen || container.msRequestFullscreen || container.requestFullscreen;
		rFS.call(container);
	}

	exitFullscreen() {
		if (document.webkitExitFullscreen) {
			/* Chrome, Safari and Opera */
			document.webkitExitFullscreen();
		} else {
			document.exitFullscreen();
		}
	}

	enterSemiFullscreen() {
		lutify.activeSemiFullscree = true;
		this.container.main.addClass("--fullscreen");
		this.container.mainCanvases.find(".tools-container").addClass("hide");
		this.message.activate("Press Esc to exit");
		this.canvas.setSizeCSS();
		if (lutify.splitViewActive) lutify.refreshSplitView();
		gpu.render(); //Safari fix
	}

	exitSemiFullscreen() {
		lutify.activeSemiFullscree = false;
		this.container.main.removeClass("--fullscreen");
		this.container.mainCanvases.find(".tools-container").removeClass("hide");
		this.canvas.setSizeCSS();
		if (lutify.splitViewActive) lutify.refreshSplitView();
		gpu.render(); //Safari fix

		lutPreviewer.updateSize();
		this.lutPreviewThumbnail.setSize(lutPreviewer.width, lutPreviewer.height);
		lutPreviewer.render();
	}

	showSplitView(image) {
		let container = $('<div id="twentyContainer"></div>');
		$(container).append(image);

		$(container).css("width", UI.canvas.$el.width());
		$(container).css("height", UI.canvas.$el.height());
		// $(container).css("left", UI.canvas.$el.offset().left);
		// $(container).css("top", UI.canvas.$el.offset().top);

		$("#content").append(container);
		$(container).twentytwenty({
			no_overlay: true,
		});
		$(".twentytwenty-handle").css("left", parseFloat(lutify.splitSlider) * 100 + "%");

		vm.$store.dispatch('UI/setSplitView', true);
	}

	showColorWorkflowNotification() {
		if (UI.modals.colorWorkflowNotification.el.is(":visible")) return;
		if (Cookies.get("acceptedColorWorkflow")) return;

		UI.showModal(UI.modals.colorWorkflowNotification.el);
	}

	showColorWorkflowPresetNotification() {
		if (Cookies.get("acceptedColorWorkflowPreset")) return;

		UI.hideModal();
		UI.showModal(UI.modals.colorWorkflowPresetNotification.el);
	}

	presetTransformsSelection() {
		return new Promise((resolve, reject) => {
			UI.modals.presets.transformsMismatch.el
				.find('[data-modal-action="keep-transforms"]')
				.off("click")
				.on("click", () => {
					resolve("keep-transforms");
				});
			UI.modals.presets.transformsMismatch.el
				.find('[data-modal-action="replace-transforms"]')
				.off("click")
				.on("click", () => {
					resolve("replace-transforms");
				});
		});
	}

	attachTemporaryLUTSelectionHandler() {
		this.getActiveBlock().on("mouseover", ".lut-selector__items-container > span", e => {
			lutPreviewer.applyPreviewPass(e.currentTarget.dataset.composerIndex);
			lutify.tempSelectedComposerIndex = e.currentTarget.dataset.composerIndex;
		});

		this.getActiveBlock().on("mouseout", ".lut-selector__items-container", e => {
			let selectedPreview;
			if (lutify.getActiveBlock().name == "magicMode") selectedPreview = lutify.getActiveBlock().selectedPreview[lutify.magicMode.activeStep]
			else if (lutify.getActiveBlock().name == "AIMagicMode") selectedPreview = lutify.getActiveBlock().selectedPreview[lutify.AIMagicMode.activeStep]
			else if (lutify.getActiveBlock().name == "customLUT" || lutify.getActiveBlock().name == "CustomLutV2") selectedPreview = luts.getComposerIndexById("customLUT", lutify.getActiveBlock().lut.id);
			else selectedPreview = lutify.getActiveBlock().selectedPreview;

			if (lutify.tempSelectedComposerIndex) {
				if (selectedPreview) lutPreviewer.applyPreviewPass(selectedPreview);
				else lutPreviewer.removePreviewPass(lutify.tempSelectedComposerIndex);
			}

			lutify.tempSelectedComposerIndex = null;
		});
	}

	resetIDTODT() {
		this.IDT.btn.find(".menu-label").html("Select Input Transform");
		this.ODT.btn.find(".menu-label").html("Output Transform");
		this.ODT.btn.addClass("--disabled");
	}

	enableODT() {
		this.ODT.btn.removeClass("--disabled");
		this.ODT.btn.find("i").removeClass("hide");
	}

	createPlaceholder(display = false) {
		let element = '<div class="list-item thumbnail-canvas placeholder-container --placeholder" data-category="placeholder" ';
		if (!display) element += 'style="display: none">';
		else element += ">";
		element += '<span class="placeholder-preview"></span>';
		element += '<span class="placeholder-label"></span>';
		element += "</div>";
		return element;
	}

	createFileThumbnailPlaceholder() {
		let element = '<div class="placeholder-container --placeholder">';
		element += '<span class="placeholder-preview"></span>';
		element += "</div>";
		return element;
	}

	initKnob(element, options = {}) {
		$(element)
			.find(".input-knob")
			.knob({
				stopper: false,
				displayInput: false,
				width: options.size ? options.size : 50,
				height: options.size ? options.size : 50,
				min: 0,
				max: 10,
				release: function () {
					UI.mouse.knobDrag = false;
				},
				change: function () {
					UI.mouse.knobDrag = true;
					if (this.cv == this.nextStepValue) return;

					let inputControl = this.$div.siblings("input");
					let inputControlStep = parseFloat(inputControl.attr("step"));
					let currentInputValue = parseFloat(inputControl.val());
					let newInputValue;

					if (this.nextStepValue > this.cv) {
						newInputValue = currentInputValue - inputControlStep;
					} else {
						newInputValue = currentInputValue + inputControlStep;
					}

					if (options.outputInteger) {
						newInputValue = parseInt(newInputValue);
					} else {
						let toFixedValue = inputControlStep.toString().length - 1 - inputControlStep.toString().indexOf(".");
						newInputValue = newInputValue.toFixed(toFixedValue);
					}

					// console.log(inputControl, newInputValue);
					inputControl.val(newInputValue);
					inputControl.trigger("change");

					this.nextStepValue = this.cv;
				},
			});
	}

	paneResized() {
		// Only execute when the main image is loaded
		if (loader.activeMedia.file) {
			// assign new max-width and max-height for canvas, calculated from available space
			UI.canvas.setSizeCSS();
			scopes.setMaxSize();

			if (lutify.splitViewActive === true) {
				var myCanvasOffset = UI.canvas.$el.offset();
				$("#twentyContainer").height(UI.canvas.$el.height());
				$("#twentyContainer").width(UI.canvas.$el.width());
				$(".twentytwenty-handle").css("left", parseFloat(lutify.splitSlider * 100) + "%");
			}

			if (lutify.blocks.some(block => block.name == "smartCurves")) {
				lutify.blocks.forEach((block, index) => {
					if (block.name == "smartCurves") {
						let blockEl = UI.getAdjustmentBlock(block.blockNum)
						window._Adjustments.smartCurves.updateCanvsesSize($(blockEl));
						window._Adjustments.smartCurves.drawGrid($(blockEl).find('canvas.smart-curve-grid'));
						block.curves.forEach(curve => {
							curve.colorCurve.width = window._Adjustments.smartCurves.canvas.width;
							curve.colorCurve.height = window._Adjustments.smartCurves.canvas.height;
							curve.colorCurve.draw();
						})
					}
				});
			}

			gpu.render();
			lutPreviewer.updateSize();
			lutPreviewer.setSize();
			this.lutPreviewThumbnail.setSize(lutPreviewer.width, lutPreviewer.height);
			lutPreviewer.render();
		}

	}

	async initEvents() {
		// await vm.$store.dispatch("Projects/fetchProjects");
		// vm.$store.dispatch("Projects/setProjectsFeaturedImage");
		// if (vm.$store.state.Projects.projects.length == 0) this.showModal(this.modals.project.create);
		// else {
		// 	this.showModal(this.modals.project.selector);
		// 	this.modals.project.selector
		// 		.find(".project")
		// 		.eq(0)
		// 		.trigger("click");
		// }

		var pointerMoveStart = {};

		// Tooltip init
		UI.initTippy();

		// Saving mouse position.
		// We are using this in SmartCurve block, while dragging outside the canvas element
		document.addEventListener("mousemove", e => {
			UI.mouse.x = e.pageX;
			UI.mouse.y = e.pageY;
		});

		// document.addEventListener('mousedown', e => {
		// });

		// document.addEventListener('mouseup', e => {
		// 	UI.mouse.down = false;
		// });

		// Removing test curves if not enabled
		if (!config.testCurves.enabled) {
			$("#blocks-canvas-container")
				.children()
				.remove();
		}

		// Event handler for temporary hiding the changes by pressing and holding mousedown on canvas element
		UI.canvas.$el.on("mousedown", e => {
			if (e.which == 1) {
				lutify.canvasMouseDown = true;
				pointerMoveStart.x = e.pageX;
				pointerMoveStart.y = e.pageY;
				UI.scenePositionBuffer = $.extend({}, gpu.camera.position);

				if (!lutify.activeBefore && lutify.canvasMouseDown) {
					lutify.hideBlockSelections();
				}
			}
		});

		// Event handler for mouseup, show the changes to the user
		// This event is for hiding/showing shader changes on canvas
		$("body").on("mouseup", () => {
			if (lutify.activeBefore && lutify.canvasMouseDown) lutify.showBlockSelections();
			lutify.canvasMouseDown = false;
		});

		// Moving feature
		UI.canvas.$el.on("mousemove", e => {
			if (lutify.canvasMouseDown && lutify.moveEnabled && gpu.camera.zoom != 1) {
				let currentX = e.pageX,
					currentY = e.pageY,
					offsetX = currentX - pointerMoveStart.x,
					offsetY = currentY - pointerMoveStart.y,
					newPosition = {
						x: UI.scenePositionBuffer.x - (offsetX * gpu.canvasRatioX) / gpu.camera.zoom,
						y: UI.scenePositionBuffer.y + (offsetY * gpu.canvasRatioY) / gpu.camera.zoom,
					};

				gpu.moveScene(newPosition);
			} else return;
		});

		// ZOOM IN/OUT AND MOVING SCENE AROUND
		UI.canvas.$el.on("wheel", e => {
			if (e.originalEvent.deltaY / 120 > 0) gpu.zoomCanvas(-0.05);
			else gpu.zoomCanvas(0.05);
		});

		// Opacity slider listener from LUT preview. Controls the selected block's opacity.
		// NOTE: bottleneck when calling renderThumbnails(). Performance fix needed.
		$("#previews-list-container").on("input", ".thumbnail-slider", function () {
			const opacityValue = $(this).val();

			if (lutify.getActiveBlock()?.name == "AIMagicMode") {
				window._Adjustments.AIMagicMode.opacitySliderHandler(parseInt(opacityValue));
			} else {
				const block = UI.getBlock(lutify.activeBlock);
				block.find(".opacity_slider").val(opacityValue);
				block.find(".opacity_slider").trigger("input");
			}
		});

		$("#previews-list-container").on("dblclick", ".thumbnail-slider", function () {
			$(this).val(100).trigger("input");
		});

		$("#previews-list-container").on("change", ".thumbnail_range", function () {
			const opacityValue = $(this).val();
			if (lutify.getActiveBlock()?.name == "AIMagicMode") {
				window._Adjustments.AIMagicMode.opacityInputHandler(parseInt(opacityValue));
			} else {
				const block = UI.getBlock(lutify.activeBlock);
				block.find(".opacity_slider").val(opacityValue);
				block.find(".opacity_slider").trigger("input");
			}
		});

		// preventing right click menu onon canvas
		$("body").on("contextmenu", "canvas.rgbCurves", e => {
			return false;
		});

		UI.IDT.btn.on("click", function (e) {
			e.stopPropagation();
			if (!lutify.canUseColorGradingTools()) return;

			UI.IDT.menuContainer.toggleClass("hide");
			UI.state.menu.IDT = !UI.state.menu.IDT;

			UI.toggleStartTips();

			// if (vm.$store.state.UI.startTips == 2) {
			// 	vm.$store.dispatch("UI/setStartTips", 2.5);
			// }


			createPopper(UI.IDT.btn.get(0), UI.IDT.menuContainer.get(0), {
				placement: "top-start",
				modifiers: [
					{
						name: "offset",
						options: {
							offset: [0, 10],
						},
					},
				],
			});
		});

		UI.ODT.btn.on("click", function (e) {
			e.stopPropagation();
			if (!lutify.canUseColorGradingTools()) return;

			if (e.currentTarget.classList.contains("--disabled")) return;
			UI.ODT.menuContainer.toggleClass("hide");
			UI.state.menu.ODT = !UI.state.menu.ODT;

			createPopper(UI.ODT.btn.get(0), UI.ODT.menuContainer.get(0), {
				placement: "top-end",
				modifiers: [
					{
						name: "offset",
						options: {
							offset: [0, 10],
						},
					},
				],
			});
		});

		$('.modal-btn[data-modal-action="save-match"]').on("click", function () {
			let name = UI.modals.newMatch.el.find('input[type="text"]').val();
			if (!name) name = "match-" + Date.now();
			lutify.addMatch(name);
			UI.hideModal();
		});

		$("#blocks-container").on("mousedown", ".drag-indicator", function () {
			$('#blocks-container').height(document.querySelector('#blocks-container').scrollHeight);

			$(this).addClass("--grabbing");

			lutify.getActiveBlock().wasExpandedBeforeSort = UI.getActiveBlock()
				.find(".collapse_options")
				.is(":visible");

			UI.getActiveBlock()
				.find(".collapse_options")
				.trigger("click");
		});

		$("#blocks-container").on("mouseup", ".drag-indicator", function () {
			$('#blocks-container').css('height', 'auto');

			$(this).removeClass("--grabbing");
		});

		$("#blocks-container").sortable({
			revert: 250,
			items: "li",
			handle: ".drag_handle .drag-indicator",
			// containment: "parent",
			scroll: true,
			// helper: "clone",
			placeholder: "block-placeholder",
			// opacity: 0.3,
			axis: "y",
			// tolerance: "pointer",
			// cursor: 'grabbing',
			start: function (event, ui) {
				let currentElement = ui.item[0];
				let height = currentElement.clientHeight;
				let width = currentElement.clientWidth;

				$(".block-placeholder").height(height);
				$(".block-placeholder").width(width);
			},
			stop: function (event, ui) {
				if (lutify.getActiveBlock().wasExpandedBeforeSort) {
					UI.getActiveBlock()
						.find(".expand_options")
						.trigger("click");
				}

				delete lutify.getActiveBlock().wasExpandedBeforeSort;

				// $(ui.item[0]).removeClass('--grabbing');
				let blockNum = ui.item.attr("orignum");
				let newBlockIndex = ui.item.index();
				blocks.moveBlock(blockNum, newBlockIndex);

				document.querySelectorAll('#blocks-container .adjustment-block').forEach(el => {
					if (el.classList.contains('colour-match-block') ||
						el.classList.contains('colour-match-v2-block') ||
						el.classList.contains('ai-auto-correct-block') ||
						el.classList.contains('ai-auto-correct-v2-block') ||
						el.classList.contains('ai-colour-extract-v2-block') ||
						el.classList.contains('ai-colour-match-block') ||
						el.classList.contains('ai-colour-match-v2-block')
					) {
						$(el).find('.btn-block-needs-update').removeClass('hide');
					}
				});

				gpu.composer.passes = blocks.getPasses_fromAllBlocks();
				gpu.render();
				if ($(ui.item[0]).hasClass("look_block")) {
					lutPreviewer.cloneMainComposerPasses();
					lutPreviewer.addPass(lutify.getActiveBlock().control, lutify.getActiveBlock().name);
					lutPreviewer.render();
				}

				lutify.storeLastState();
			},
		});

		if (config.testCurves.enabled) {
			$("#curveSelect").on("change", function () {
				$(`canvas[data-id="${$(this).val()}"]`).fadeIn();
				$(`.canvas-container[data-name="${$(this).val()}"]`).fadeIn();
			});

			$("#blocks-canvas-container").draggable({
				opacity: 0.35,
				zIndex: 100,
			});

			$("#reset-selected-canvases-btn").on("click", function () {
				$("#blocks-canvas-container .rgbCurves").fadeOut();
				$("#blocks-canvas-container .canvas-container").fadeOut();
				$("#blocks-canvas-container #curveSelect").val("default");
			});
		}

		$('.modal-btn[data-modal-action="close-modal"]').on("click", function () {
			UI.hideModal();
		});

		$('.modal-btn[data-modal-action="reset-scene"]').on("click", function () {
			lutify.resetScene();
			UI.hideModal();
		});

		$(".modal-new .btn-close-modal").on("click", function () {
			UI.hideModal();
		});

		// For closing menus
		$("body").on("click", e => {
			if (UI.state.menu.IDT) {
				if (!UI.IDT.menuContainer.get(0).contains(e.target)) {
					UI.IDT.menuContainer.toggleClass("hide");
					UI.state.menu.IDT = false;
					UI.toggleStartTips();
				}
			}

			if (UI.state.menu.ODT) {
				if (!UI.ODT.menuContainer.get(0).contains(e.target)) {
					UI.ODT.menuContainer.toggleClass("hide");
					UI.state.menu.ODT = false;
				}
			}

			if (
				UI.getActiveBlock()
					.find(".block-opacity__items-container")
					.is(":visible")
			) {
				if (
					!UI.getActiveBlock()
						.find(".block-opacity__items-container:visible")
						.get(0)
						.contains(e.target)
				) {
					UI.getActiveBlock()
						.find(".block-opacity__items-container:visible")
						.hide();
				}
			}

			if (
				UI.getActiveBlock()
					.find(".blending-mode__items-container")
					.is(":visible")
			) {
				if (
					!UI.getActiveBlock()
						.find(".blending-mode__items-container:visible")
						.get(0)
						.contains(e.target)
				) {
					UI.getActiveBlock()
						.find(".blending-mode__items-container:visible")
						.hide();
				}
			}

			if (
				UI.getActiveBlock()
					.find(".lut-selector__items-container")
					.is(":visible")
			) {
				if (
					!UI.getActiveBlock()
						.find(".lut-selector__items-container:visible")
						.get(0)
						.contains(e.target)
				) {
					UI.getActiveBlock()
						.find(".lut-selector__items-container")
						.hide();
				}
			}

			if (
				$(".modal-new")
					.find(".control-selector__items-container")
					.is(":visible")
			) {
				if (
					!$(".modal-new")
						.find(".control-selector__items-container:visible")
						.get(0)
						.contains(e.target)
				) {
					$(".modal-new")
						.find(".control-selector__items-container:visible")
						.hide();
				}
			}

			if (lutify.activeModal && $(e.target).hasClass('overlay')) {
				UI.hideModal();
			}
		});

		$('.modal-btn[data-modal-action="accept-color-workflow"]').on("click", function () {
			if (UI.modals.colorWorkflowNotification.el.find('input[type="checkbox"]').is(":checked")) {
				Cookies.set("acceptedColorWorkflow", true);
			}

			UI.hideModal();
		});

		UI.container.scopes.find("#btn-close-scopes").on("click", _ => {
			lutify.hideScopes();
		});

		["fullscreenchange", "webkitfullscreenchange"].forEach(eventName => {
			document.addEventListener(eventName, function () {
				if (document.fullscreenElement || document.webkitFullscreenElement) {
					lutify.fullscreen = true;
					UI.container.mainCanvases.addClass("--fullscreen");
					UI.canvas.$el.addClass("--fullscreen");
				} else {
					lutify.fullscreen = false;
					UI.container.mainCanvases.removeClass("--fullscreen");
					UI.canvas.$el.removeClass("--fullscreen");
				}

				UI.refreshScene();
				setTimeout(() => {
					UI.refreshScene();
				}, 500)
			});
		})

		UI.btn.importPreset.on("click", _ => {
			UI.hideModal();
			UI.showModal(UI.modals.presets.import.el);
		});

		// NOTE needs refactoring - place inside presets compoents
		// Dropdowns COMPONENT
		$(".dropdown-component .control-selector__label-container").on("click", e => {
			e.stopPropagation();
			if ($(e.currentTarget).hasClass("--disabled")) return;

			let itemsContainer = $(e.currentTarget).siblings(".control-selector__items-container");
			if (itemsContainer.is(":visible")) itemsContainer.hide();
			else itemsContainer.show();
		});

		$(".dropdown-component").on("click", ".control-selector__items-container > span", e => {
			e.stopPropagation();
			// $(e.currentTarget)
			// 	.closest(".dropdown-component")
			// 	.find(".selected-control-name")
			// 	.html(e.currentTarget.dataset.name);
			$(e.currentTarget)
				.closest(".control-selector__items-container")
				.hide();
		});

		$(".modal-new .regex-check").on("keydown", function (e) {
			if (!lutify.testInputRegex(e.key)) {
				e.preventDefault();
				$(this).val(
					$(this)
						.val()
						.toString() + "-"
				);
				return false;
			}
		});

		$(window).on("beforeunload, blur", async function (e) {
			if (Cookies.get("DISABLE_ON_BLUR")) return;

			// // Cancel the event (if necessary)
			e.preventDefault();

			await lutify.storeLastState();
			// await lutify.pushLastStates();
		});

		window.addEventListener("focus", async function () {
			if (Cookies.get("DISABLE_ON_BLUR")) return;
			if (vm.$store.getters['User/isMemberOrLower']) return;

			if (vm.$store.state.Projects.project.id && !vm.$store.state.Projects.uploadStatus && vm.$route.name == 'app') {
				await vm.$store.dispatch("Projects/refreshProjectTree");
				// vm.$store.dispatch("Projects/fetchThumbnails");
			}

			let imageId = window.vm.$store.state.Projects.image;
			if (!imageId || !vm.$store.getters['Projects/imageById'](imageId)) return;

			setTimeout(async () => {
				let response = await vm.$store.dispatch("UserFiles/fetchLastState", imageId);
				let lastState = await window.imagesStateStore.getItem(imageId);
				if (response && lastState) {
					if (response.timestamp > lastState.timestamp) {
						// console.log("Fetched state is newer than local version");
						await window.imagesStateStore.removeItem(imageId);
						await window.imagesStateStore.setItem(imageId, response);
						await window.lutify.applyLastState(imageId);
					}
				}
			}, 1000);
		});

		$(window).on("resize", function () {
			UI.paneResized();
		});
	}
}
